module.exports = __webpack_public_path__ + "static/media/purepapercolor-skin-slate-08-1200x2490.b0ffc447.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapercolor-skin-slate-08-1200x2490.jpg
// module id = 1100
// module chunks = 37